(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  let checks = 0;
  const ptppLooxPopup = document.querySelector('[data-ptpp-loox-popup]');
  if (ptppLooxPopup) {
    function checkLOOX() {
      if (!window.LOOX && checks < 3) {
        checks += 1;
        setTimeout(function() {
          checkLOOX();
        },400);
      } else {
        ptppLooxPopup.classList.remove('loading');
      }
    }
    checkLOOX();
    ptppLooxPopup.addEventListener('click', function() {
      window.LOOX.openVisitorLevelReferralModal();
    });
  }
  class OfficialMerch extends HTMLElement {
    constructor() {
      super();      
    }
    connectedCallback() {
      this.querySelector('button').addEventListener('click', this.openOfficialMerchPopup);
    }
    openOfficialMerchPopup() {
      console.log('click');
    }
  }
  customElements.define('official-merch', OfficialMerch);
  class ArtistsList extends HTMLElement {
    links = [];
    artists = [];
    loaded = false;
    loading = false;
    artistsList = null;
    constructor() {
      super();
      this.onLetterMouseOver = this.onLetterMouseOver.bind(this);
      this.showLetter = this.showLetter.bind(this);
      this.showArtistsList = this.showArtistsList.bind(this);
      this.hideArtistsList = this.hideArtistsList.bind(this);
    }
    connectedCallback() {
      this.links = this.querySelectorAll('a');
      this.artistsList = this.querySelector('[data-artists-list]')
      this.addEventListener('mouseover', this.showArtistList);
      this.addEventListener('mouseleave', this.hideArtistsList);
      const artists = this.querySelector('#top-bar-artists');
      if (artists) {
        try {
        this.artists = JSON.parse(artists.innerHTML);
        } catch(error) {
          console.error(error);
        }
      }
      if (this.links.length > 0) {
        [...this.links].map((link) => {
          link.addEventListener('click', this.onLetterClick);
          link.addEventListener('mouseover', this.onLetterMouseOver);          
        }) 
      }
    }
    onLetterMouseOver(e) {
      // if (this.links.length > 0) {
      //   [...this.links].map((link) => {
      //     link.removeEventListener('mouseover', this.onLetterMouseOver);
      //   });
      // }
      const letter = e.target.href.split('#letter-').pop();
      // if (!this.loaded && !this.loading) {
      //   const _that = this;
      //   _that.loading = true;
      //   import("https://d3js.org/d3.v7.min.js").then(moduleData => {
      //     fetch('/pages/artists').then(res =>res.text()).then(data => {
      //       const parser = new DOMParser();
      //       const newDom = parser.parseFromString(data,'text/html');
      //       const container = newDom.querySelector("[data-artists]");
      //       if (container) {
      //         const csvData = container.innerText;
      //         this.artists = d3.csvParse(csvData).map((artist) => {
      //           return {
      //             ...artist,
      //             genre: artist.genre.trim().split(';'),
      //           };
      //         });
      //         _that.showLetter(letter);
      //         _that.loaded = true;
      //         _that.loading = false;
      //       }
      //     });
      //   });
      // } else {
        this.showLetter(letter);
      // }
    }
    showArtistsList() {
      this.artistsList.setAttribute('aria-expanded','true');
    }
    hideArtistsList(e) {
      this.artistsList.setAttribute('aria-expanded','false');
    }
    showLetter(letter) {
      const letters = "abcdefghijklmnopqrstuvwxyz".split('');
      const filteredArtistsByLetter = this.artists.filter((artist) => {
        if (letter === 'other') {
          return !letters.includes(artist.name[0].toLowerCase());
        } else {          
          return artist.name[0].toLowerCase() === letter
        }
      });
      const list = document.createElement('ul');
      list.className = 'page-width';
      const content = filteredArtistsByLetter.slice(0,23).map((artist) => {
        let target = "";
        if (artist?.url?.includes('http')) {
          target = 'target="_blank"';
        }
        return `<li><a href="${artist.url}" ${target}>${artist.name}</a></li>`;
      })
      content.push(`<li><a href="/pages/artists/#letter-${letter}">...view all artists</a></li>`);
      list.innerHTML = content.join('');
      if (this.artistsList) {
        this.artistsList.innerHTML = "";
        this.artistsList.appendChild(list);
        this.artistsList.setAttribute('aria-expanded','true');
      }
    }
    onLetterClick(e) {
      if (window.location.href.includes('/pages/artists')) {
        const hash = e.target.href.split('#').pop();
        const element = document.querySelector(`#${hash}`);
        if (element) {
          window.history.pushState(null, null, e.target.href);
          window.scrollTo({
            top: window.scrollY + element.getBoundingClientRect().top - 160,
            left: 0,
            behavior: 'smooth',
          });
        }
        e.preventDefault();
        return false;
      }
    }
  }
  customElements.define('artists-list', ArtistsList);
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
